import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const bleeding: AnswerPathTreeNode = {
  path: 'bleeding',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredBleedingDetails }],
};
